import type { SVGProps } from 'react'

export const AngleIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    aria-hidden="true"
    fill="none"
    focusable="false"
    viewBox="0 0 14 16"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.29377 11.7063C6.6844 12.0969 7.31877 12.0969 7.7094 11.7063L12.7094 6.70627C13.1 6.31565 13.1 5.68127 12.7094 5.29065C12.3188 4.90002 11.6844 4.90002 11.2938 5.29065L7.00002 9.5844L2.70627 5.29377C2.31565 4.90315 1.68127 4.90315 1.29065 5.29377C0.900024 5.6844 0.900024 6.31877 1.29065 6.7094L6.29065 11.7094L6.29377 11.7063Z"
      fill="currentColor"
    />
  </svg>
)
